<template>
    <div v-clickaway="close" class="unread-referral-messages">
        <div @click="open()">
            <common-icon class="unread-referral-messages__icon" name="chat-circle" size="gigantic"></common-icon>
            <div class="unread-referral-messages__background"></div>
            <div class="unread-referral-messages__amount">{{ unreadMessagesCount }}</div>
        </div>
        <common-dropdown
            :isOpen="isOpen"
            :hasArrow="isOpen"
            :recalculatePosition="true"
            bgColor="gray"
            arrowPositionY="top"
            arrowPositionX="right"
            class="unread-referral-messages__dropdown"
        >
            <common-content-spacer height="tiny" class="unread-referral-messages__container">
                <div
                    v-for="(message, index) in unreadMessages"
                    :key="index"
                    v-bind="{ route: { name: 'index.home' } }"
                    class="unread-referral-messages__row"
                    @click="goToReferral(message)"
                >
                    <p
                        class="unread-referral-messages__row__text"
                        v-html="message.body.length > 30 ? message.body.slice(0, 27) + '...' : message.body"
                    ></p>
                    <common-user-avatar
                        :user="{ name: fromUserName(message) }"
                        :isUserProfileLinkEnabled="false"
                        size="label"
                        class="unread-referral-messages__row__avatar"
                    ></common-user-avatar>
                </div>

                <div v-if="!unreadMessages.length" class="unread-referral-messages__row">
                    <p>{{ $t('modals.referral_unread_messages.no_new_messages') }}</p>
                </div>
            </common-content-spacer>
        </common-dropdown>
    </div>
</template>

<script>
    import Store from '@/store'
    import MessagesAPI from 'api/MessagesAPI'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        data() {
            return {
                isOpen: false,
                userId: null,
                unreadMessages: [],
                PracticeTypeEnum: PracticeTypeEnum,
            }
        },

        computed: {
            unreadMessagesCount() {
                return Store.getters['chat-messages/getUnread'].length
            },
        },

        methods: {
            fromUserName(message) {
                return message.fromUser ? message.fromUser.firstName + ' ' + message.fromUser.lastName : message.practice.name
            },
            close() {
                this.isOpen = false
            },
            open() {
                this.getUnreadMessages()
                this.isOpen = true
            },
            goToReferral(message) {
                let type = this.$auth.getUser().id === message.properties.referralFromUserId ? 'made' : 'received'
                this.$router.push({
                    name: `referrals.${type}.show`,
                    params: { id: message.objectId },
                    query: { openChat: true },
                })
                this.close()
            },
            getUnreadMessages() {
                const _fields = [
                    'objectId',
                    'body',
                    'fromUser(id,designation,firstName,lastName,userRole(id,name))',
                    'properties(referralFromUserId,referralToUserId)',
                    'practice(name)',
                ]
                const query = {
                    toUserId:
                        this.$auth.getPractice().practiceType === this.PracticeTypeEnum.ANCILLARY ? 0 : this.$auth.getUser().id,
                    toPracticeId: this.$auth.getPractice().id,
                }
                MessagesAPI.getUnread(query, _fields).then((resp) => {
                    Store.dispatch('chat-messages/setUnread', resp)
                    this.unreadMessages = resp
                    return resp
                })
            },
        },
    }
</script>
